module.exports = __webpack_public_path__ + "img/SC5-Income_&_savings.fb38e76d.png";